import React from 'react'
import PropTypes from 'prop-types'
import kebabCase from 'lodash/kebabCase'
import { dynamicDataAttribute, toOneString } from 'helpers/utils'
import Media from 'components/common/Media'
import { FilterFacet } from './FilterGroup.styles'
import FilterOption from './FilterOption'
import FilterGroupToggle from './FilterGroupToggle'

const FilterGroup = ({
  className,
  expandable,
  expanded,
  onChange,
  options,
  title,
  isGroupOpen,
  toggleHandlers,
  children,
  dataAttribute,
  toggleOnName,
  toggleOffName
}) => {
  const filterId = `filter_${kebabCase(title)}`
  const filterDrawerButtonId = `${filterId}_drawer-button`
  const filterOptionsId = `${filterId}_options`

  return (
    <FilterFacet
      id={ filterId }
      isFilterGroup
      dataAttribute={ dataAttribute }
      className={ className }
      title={ title }
      expandedByDefault={ isGroupOpen }
      disableResetOnLocationChange
      preventHandleBlur>
      <fieldset id={ filterOptionsId } aria-labelledby={ filterDrawerButtonId }>
        <legend><Media.ScreenReader>{ title }</Media.ScreenReader></legend>
        {
          options.map((data, index) =>
            <FilterOption
              { ...data }
              key={ data.label + data.navigationState + index }
              dataAttributes={ dynamicDataAttribute('filter-option', toOneString(data.label)) }
              onSelect={ onChange } />
          )
        }
      </fieldset>
      { children }
      {
        expandable &&
        <FilterGroupToggle
          toggleOnName={ toggleOnName }
          toggleOffName={ toggleOffName }
          expanded={ expanded }
          toggleHandlers={ toggleHandlers }
          aria-controls={ filterOptionsId } />
      }
    </FilterFacet>
  )
}

export default FilterGroup

FilterGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataAttribute: PropTypes.shape(),
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  isGroupOpen: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  }),
  toggleOffName: PropTypes.string,
  toggleOnName: PropTypes.string
}
